export default "__VITE_ASSET__DFldWTQtnRljfeuGtLqQ3g__"